module.exports = __webpack_public_path__ + "img/farming_44.7c4490e9.png";